let pews = require('./pews');
let coast = require('./coast');
let news = require('./news');
let helpers = require('./helpers');
let glyphColors = require('./glyph_colors.js');

class EWS {
    
    static evaluateClause(clause, value) {
        return Object.keys(clause)
            .map(c => helpers.conditions[c](value, clause[c]))
            .reduce(helpers.reducers.and, true);
    }

    static evaluateRule(rule, value) {
       if (rule) {
         return rule
           .map(clause => EWS.evaluateClause(clause, value))
           .reduce(helpers.reducers.or, false);
       } else {
         return 0;
       }
    }

    static isPrimitive(arg) {
        var type = typeof arg;
        return arg === null || (type != 'object' && type != 'function');
    }

    static getValueorObject(thing) {
        if (EWS.isPrimitive(thing)) {
            return thing;
        }
        if ('value' in thing) {
            return thing.value;
        }
        //for blood pressure type
        if ('sys' in thing) {
          return thing.sys;
        }
        return thing;
    }


    static evaluateCondition(otherField, otherValue, obs) {
        if (EWS.getValueorObject(obs[otherField]) === otherValue) {
            return 1;
        } else {
            return 0;
        }
    }

    static evaluateConditions(field, obs) {
        const fieldRules = helpers.EW_CONDITION_RULES[field];
        if (!fieldRules) {
            return 1;
        }
        return Object.keys(fieldRules)
            .map(otherField => EWS.evaluateCondition(otherField,
                fieldRules[otherField], obs))
            .reduce(helpers.reducers.and);
    }


    static evaluateField(rules, field, obs) {
        return EWS.evaluateConditions(field, obs) &&
            EWS.evaluateRule(rules[field], EWS.getValueorObject(obs[field]));
    }

    static getRules(age, ewsType) {
      if (ewsType == null)
      {
        console.error('no EWS set');
        return null;
      }
      if (ewsType == 'coast') {
        return coast.rules[coast.group(age)];
      }
      else if (ewsType == 'news') {
        return news.rules[news.group()];
      }
      else if (ewsType == 'pews') {
        return pews.rules[pews.group(age)];
      }
      else {
        console.error('EWS type not recognised ' + ewsType);
        return null;
      }
    }

    static score(age, field, obs, ewsType) {
      var rules = EWS.getRules(age, ewsType);

      if (rules == null) {
        return null;
      }

      var score = 0;

      if (EWS.evaluateConditions(field, obs)) {
        score = EWS.evaluateRule(rules[field], EWS.getValueorObject(obs[field]));
        if (typeof(score) === 'boolean') {
          score = score ? 1 : 0
        }
      }

      return score;

    };

    static calc_pews_score(age, field, obs) {
      return EWS.score(age, field, obs, 'pews');
    }

    static calc_coast_score(age, field, obs) {
      return EWS.score(age, field, obs, 'coast');
    }

    static calc_news_score(age, field, obs) {
      return EWS.score(age, field, obs, 'news');
    }

    static calculate(age, obs, ewsType) {
        var rules = EWS.getRules(age, ewsType);

        if (rules == null) {
          return null;
        }

        return Object.keys(rules)
            .map(field => EWS.evaluateField(rules, field, obs))
            .reduce(helpers.reducers.add, 0);
    };

    static calc_pews(age, obs) {
      return EWS.calculate(age, obs, 'pews')
    }

    static calc_coast(age, obs) {
      return EWS.calculate(age, obs, 'coast')
    }

    static calc_news(age, obs) {
      return EWS.calculate(age, obs, 'news')
    }

    static calc_age_range(age, ewsType) {
        if (ewsType == 'pews') {
            return pews.ageRange[pews.group(age)];
        } else if (ewsType == 'coast') {
            return coast.ageRange[coast.group(age)];
        } else if (ewsType == 'news') {
            return news.ageRange[news.group(age)];
        } else {
            return 'Unrecognizable EWS Type';
        }
    }
  
    static calc_pews_age_range(age) {
      return EWS.calc_age_range(age, 'pews')
    }

    static calc_coast_age_range(age) {
      return EWS.calc_age_range(age, 'coast')
    }

    static calc_news_age_range(age) {
      return EWS.calc_age_range(age, 'news')
    }

    static calc_glyph_border_color(age, obs, type) {
      let ews = EWS.calculate(age, obs, type)
      if (glyphColors.border[type]) {
        return glyphColors.border[type][ews]
      }
      return;
    }

    static calc_pews_glyph_border_color(age, obs) {
      return EWS.calc_glyph_border_color(age, obs, 'pews');
    }

    static calc_coast_glyph_border_color(age, obs) {
      return EWS.calc_glyph_border_color(age, obs, 'coast');
    }
    
    static calc_news_glyph_border_color(age, obs) {
      return EWS.calc_glyph_border_color(age, obs, 'news');
    }

}

module.exports = EWS
